/* ACF · Main Product — comportamiento de la seccion: video de la slide 1, galeria
   (apilada o carrusel), y los modulos opcionales TIERS, ATC, slider de mini resenas y
   carrusel coverflow.
   Antes iba en un <script> en linea al final de la seccion, que se compilaba y se
   ejecutaba en mitad del analisis del HTML (con dos layouts forzados). Ahora se carga con
   defer. Lo que antes ponia Liquid sale del <section data-acf-mp>:
     - la raiz: el propio elemento [data-acf-mp] (antes .acf-mp-<section.id>);
     - la variante de reserva del boton ATC: data-acf-fallback-variant;
     - que modulos hay que montar: data-acf-js-tiers / -atc / -minirev / -cf, que la
       seccion solo pinta si existe el bloque correspondiente.
   No crea globales ni depende de otros scripts (Releasit, packs, acf-rsi-lines). */
(function(){
  function acfInitMainProduct(root){
  if (!root || root.getAttribute('data-acf-mp-init')) return;
  root.setAttribute('data-acf-mp-init', '1');

  /* Slide 1 animada: reproduccion nativa y a prueba de pausas.
     El <video> va muted/loop/playsinline y preload="none": no descarga nada hasta el evento
     load (o el primer gesto), y entonces se le pone el src y arranca. Este bloque pone
     ademas las redes de seguridad, porque el requisito es que no haya forma de pararlo:
       - si el navegador rechaza el autoplay (pestana en segundo plano, ahorro de bateria),
         se reintenta al volver a primer plano y en cuanto el video tenga datos;
       - si algo lo pausa (un gesto, otra pestana, el gestor de medios del sistema, otro
         script del tema), se reanuda solo;
       - el poster se funde cuando empieza a verse movimiento de verdad.
     El poster sigue siendo el elemento que mide Lighthouse como LCP: pesa 10 KB y va
     precargado, mientras que el video entra por su cuenta. */
  var heroSlide = root.querySelector('[data-hero-slide]');
  var heroVideo = root.querySelector('[data-hero-video]');
  if (heroSlide && heroVideo) {
    var heroKeepPlaying = true;
    var heroStarted = false;

    /* PERF: el video no se descarga al entrar. Sus 113 KB competian con el pixel de Meta
       y con el resto de la pagina. Lo que se ve primero es el poster (el LCP), asi que
       retrasar el video hasta el evento load no cambia nada visible. */
    function heroStart() {
      if (heroStarted) return;
      heroStarted = true;
      var src = heroVideo.querySelector('source[data-src]');
      if (src) { src.src = src.getAttribute('data-src'); src.removeAttribute('data-src'); heroVideo.load(); }
      heroTryPlay();
    }
    function heroKick() { heroStart(); heroTryPlay(); }

    function heroTryPlay() {
      if (!heroStarted || !heroKeepPlaying || !heroVideo.paused) return;
      heroVideo.muted = true;           /* requisito del autoplay en todos los navegadores */
      var pr = heroVideo.play();
      if (pr && pr.catch) pr.catch(function () { /* se reintenta en el siguiente evento */ });
    }

    heroVideo.addEventListener('playing', function () {
      heroSlide.classList.add('is-playing');
    });

    /* Reanudar pase lo que pase. */
    heroVideo.addEventListener('pause', heroTryPlay);
    heroVideo.addEventListener('canplay', heroTryPlay);
    heroVideo.addEventListener('loadeddata', heroTryPlay);
    heroVideo.addEventListener('stalled', heroTryPlay);
    heroVideo.addEventListener('suspend', heroTryPlay);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') heroTryPlay();
    });
    window.addEventListener('pageshow', heroTryPlay);
    /* Ultimo recurso: si el navegador exige un gesto del usuario, el primero que haga sirve. */
    ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, heroKick, { once: true, passive: true });
    });

    if (document.readyState === 'complete') heroStart();
    else window.addEventListener('load', heroStart, { once: true });
  }

  /* Videos del producto que no son la slide 1: se cargan y arrancan cuando su slide pasa a
     estar activa, y se pausan al salir. Asi no descargan nada mientras no se les mire. */
  function acfStartSlideVideo(vid) {
    var src = vid.querySelector('source[data-src]');
    if (src) { src.src = src.dataset.src; src.removeAttribute('data-src'); vid.load(); }
    vid.addEventListener('playing', function () {
      this.closest('.acf-mp__main-slide').classList.add('is-playing');
    }, { once: true });
    var pr = vid.play();
    if (pr && pr.catch) pr.catch(function () {});
  }
  function acfActivateSlide(i) {
    var slides = track ? track.children : [];
    for (var k = 0; k < slides.length; k++) {
      var vid = slides[k].querySelector('[data-slide-video]');
      if (!vid) continue;
      if (k === i) {
        acfStartSlideVideo(vid);
      } else if (!vid.paused) {
        vid.pause();
      }
    }
  }

  /* GALLERY */
  var track = root.querySelector('[data-track]');
  var thumbs = root.querySelectorAll('[data-thumb]');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');
  var slides = track ? track.children.length : 0;
  var idx = 0;
  function go(i){
    if (!slides) return;
    idx = (i + slides) % slides;
    track.style.transform = 'translateX(' + (-idx * 100) + '%)';
    thumbs.forEach(function(t){ t.classList.toggle('is-active', parseInt(t.dataset.thumb,10) === idx); });
    acfActivateSlide(idx);
  }
  var galStacked = root.querySelector('.acf-mp__gallery--stacked');
  if (galStacked && track) {
    /* Galeria apilada. Movil: el track hace scroll nativo con snap; aqui solo se lee la
       posicion para mover la barra y arrancar el video de la slide visible.
       Escritorio: todas las slides estan a la vista, asi que cada video se carga cuando
       entra en pantalla y se pausa al salir. */
    var galBar = root.querySelector('[data-gal-bar]');
    var galMobile = window.matchMedia('(max-width: 900px)');
    var galCur = -1, galRaf = 0;
    function galSync() {
      /* Paso real entre slides: ya no es el ancho del track, porque asoma la siguiente. */
      var kids = track.children;
      var w = (kids.length > 1 ? kids[1].offsetLeft - kids[0].offsetLeft : track.clientWidth) || 1;
      var i = Math.max(0, Math.min(slides - 1, Math.round(track.scrollLeft / w)));
      if (galBar) galBar.style.setProperty('--i', i);
      if (i !== galCur) { galCur = i; acfActivateSlide(i); }
    }
    track.addEventListener('scroll', function () {
      if (galRaf || !galMobile.matches) return;
      galRaf = requestAnimationFrame(function () { galRaf = 0; galSync(); });
    }, { passive: true });
    /* PERF: la primera lectura (offsetLeft/scrollLeft) va al siguiente frame, donde el
       navegador maqueta de todos modos, en vez de forzar un layout en plena carga. Lee la
       posicion real, asi que vale aunque el usuario ya haya deslizado la galeria. */
    if (galMobile.matches) requestAnimationFrame(galSync);
    if ('IntersectionObserver' in window) {
      var galIO = new IntersectionObserver(function (entries) {
        if (galMobile.matches) return;
        entries.forEach(function (en) {
          var vid = en.target.querySelector('[data-slide-video]');
          if (!vid) return;
          if (en.isIntersecting) acfStartSlideVideo(vid);
          else if (!vid.paused) vid.pause();
        });
      }, { threshold: 0.35 });
      Array.prototype.forEach.call(track.children, function (sl) {
        if (sl.querySelector('[data-slide-video]')) galIO.observe(sl);
      });
    }
  } else {
    if (prevBtn) prevBtn.addEventListener('click', function(){ go(idx-1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ go(idx+1); });
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(parseInt(t.dataset.thumb,10)); }); });
    if (track) {
      var sx = 0;
      track.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
      track.addEventListener('touchend', function(e){
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(dx < 0 ? idx+1 : idx-1);
      }, {passive:true});
    }
  }

  /* state lo comparten TIERS y ATC (atc implica tiers), asi que va fuera de los if. */
  var state = { variantId: null, qty: 1 };
  if (root.hasAttribute('data-acf-js-tiers')) {
  /* TIERS */
  var tiers = root.querySelectorAll('[data-tier]');
  var refresh = function(){
    var t = root.querySelector('[data-tier].is-active') || tiers[0];
    if (t) {
      state.variantId = t.dataset.variantId;
      state.qty = parseInt(t.dataset.qty, 10) || 1;
    }
  };
  tiers.forEach(function(t){
    t.addEventListener('click', function(){
      tiers.forEach(function(tt){ tt.classList.remove('is-active'); tt.setAttribute('aria-pressed','false'); });
      t.classList.add('is-active'); t.setAttribute('aria-pressed','true');
      refresh();
    });
    t.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); } });
  });
  if (!root.querySelector('[data-tier].is-active') && tiers.length) tiers[0].classList.add('is-active');
  refresh();
  }

  if (root.hasAttribute('data-acf-js-atc')) {
  /* ATC */
  var atcBtn = root.querySelector('[data-atc]');
  if (atcBtn) {
    atcBtn.addEventListener('click', function(){
      if (!state.variantId) {
        state.variantId = root.getAttribute('data-acf-fallback-variant');
      }
      atcBtn.disabled = true;
      var original = atcBtn.textContent;
      atcBtn.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [ { id: parseInt(state.variantId, 10), quantity: state.qty } ] })
      })
      .then(function(r){ if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function(){
        if (atcBtn.dataset.redirect === '1') { window.location.href = '/checkout'; }
        else { window.location.href = '/cart'; }
      })
      .catch(function(){
        atcBtn.disabled = false;
        atcBtn.textContent = original;
        alert('No se pudo añadir al carrito. Inténtalo de nuevo.');
      });
    });
  }

  }

  if (root.hasAttribute('data-acf-js-minirev')) {
  /* Scroll suave propio con rAF (para el slider de reseñas). */
  var acfSlideTo = function(el, to, ms) {
    var start = el.scrollLeft, delta = to - start, t0 = null;
    if (Math.abs(delta) < 2) { el.scrollLeft = to; return; }
    function step(now) {
      if (t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / ms);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      el.scrollLeft = start + delta * e;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  };

  /* mini_reviews en modo slider: scroll-snap + flechas/puntos/autoplay. */
  root.querySelectorAll('[data-acf-sl]').forEach(function (sl) {
    var track = sl.querySelector('.acf-sl__track');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('.acf-sl__slide'));
    if (slides.length < 2) return;
    var prev = sl.querySelector('.acf-sl__arrow--prev');
    var next = sl.querySelector('.acf-sl__arrow--next');
    var dots = [].slice.call(sl.querySelectorAll('.acf-sl__dot'));
    var wrap = sl.getAttribute('data-acf-sl-loop') === '1';
    var secs = parseFloat(sl.getAttribute('data-acf-sl-advance') || '0') || 0;
    var current = 0, timer = null, userStopped = false;

    function nearest() {
      var c = track.scrollLeft, best = 0, bd = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - track.offsetLeft - c);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    function sync() {
      current = nearest();
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === current);
      if (prev) prev.hidden = !wrap && current <= 0;
      if (next) next.hidden = !wrap && current >= slides.length - 1;
    }
    function go(i) {
      if (wrap) { i = (i + slides.length) % slides.length; }
      else { i = Math.max(0, Math.min(slides.length - 1, i)); }
      acfSlideTo(track, slides[i].offsetLeft - track.offsetLeft, 320);
    }
    if (prev) prev.addEventListener('click', function () { go(nearest() - 1); });
    if (next) next.addEventListener('click', function () { go(nearest() + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    var st;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(sync, 100); }, { passive: true });
    sync();
    if (secs > 0) {
      function tick() { if (!userStopped) go(nearest() + 1); }
      timer = setInterval(tick, secs * 1000);
      ['pointerdown', 'touchstart'].forEach(function (e) {
        track.addEventListener(e, function () { userStopped = true; clearInterval(timer); }, { passive: true, once: true });
      });
    }
  });

  }

  if (root.hasAttribute('data-acf-js-cf')) {
  /* MEDIA CAROUSEL — coverflow infinito basado en transform.
     Cada slide se coloca segun su posicion relativa al central, envuelta a [-mitad, mitad]:
     con 3 slides el 3º aparece a la izquierda del 1º. Al terminar el video central
     (o por temporizador) avanza uno. Solo el central carga y reproduce video. */
  root.querySelectorAll('[data-acf-cf]').forEach(function (cf) {
    var stage = cf.querySelector('.acf-cf__stage');
    var slides = [].slice.call(cf.querySelectorAll('[data-cf-slide]'));
    var n = slides.length;
    if (!n) return;
    var advAttr = cf.getAttribute('data-cf-advance') || 'ended';
    var loopVideo = cf.getAttribute('data-cf-loopvideo') === '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0, paused = true, advTimer = null, sideCount = n >= 5 ? 2 : 1;
    var revWrap = cf.parentNode ? cf.parentNode.querySelector('[data-cf-revs]') : null;
    var revEls = revWrap ? [].slice.call(revWrap.querySelectorAll('[data-cf-rev]')) : [];
    function syncRevs() {
      if (!revEls.length) return;
      var shown = null;
      revEls.forEach(function (r) {
        var on = parseInt(r.getAttribute('data-cf-rev'), 10) === current;
        r.classList.toggle('is-current', on);
        if (on) shown = r;
      });
      if (revWrap) revWrap.style.display = (shown && shown.querySelector('.acf-cf__rev-text')) ? '' : 'none';
    }

    function px(v) { return parseFloat(v) || 0; }
    function relPos(i) {
      var raw = ((i - current) % n + n) % n;      /* 0..n-1 */
      if (raw > n / 2) raw -= n;                   /* -> negativo para envolver */
      return raw;
    }
    var arw = parseFloat(cf.getAttribute('data-cf-arw')) || 9;
    var arh = parseFloat(cf.getAttribute('data-cf-arh')) || 16;
    var lastW = 0, laidOut = false;
    function layout(instant) {
      var cs = getComputedStyle(cf);
      var gap = px(cs.getPropertyValue('--cf-gap')); if (!gap && gap !== 0) gap = 10;
      var w = slides[0].offsetWidth;   /* offsetWidth ignora el scale() -> ancho real del slide */
      if (!w) {
        if (!cf._poll) cf._poll = setInterval(function () {
          if (slides[0].offsetWidth) { clearInterval(cf._poll); cf._poll = null; layout(true); }
        }, 120);
        return;
      }
      /* la primera vez SIEMPRE instantaneo: "primera asignacion de transform + transition
         activa" deja el transform en identidad en varios navegadores. */
      if (!laidOut) instant = true;
      /* altura del escenario segun el slide central y su proporcion */
      stage.style.height = Math.round(w * arh / arw) + 'px';
      var half = w / 2;
      var step = w + gap;                                   /* sin solape: se ven, no se tocan */
      var scale = px(cs.getPropertyValue('--cf-scale')) || 0.9;
      var op = px(cs.getPropertyValue('--cf-opacity')) || 0.55;
      if (instant) { cf.classList.remove('acf-cf--anim'); }
      slides.forEach(function (s, i) {
        var pos = relPos(i);
        var visible = Math.abs(pos) <= sideCount;
        s.style.transform = 'translateX(' + (pos * step - half).toFixed(1) + 'px) scale(' + (pos === 0 ? 1 : scale).toFixed(3) + ')';
        s.style.opacity = visible ? (pos === 0 ? 1 : op) : 0;
        s.style.zIndex = 20 - Math.abs(pos);
        s.style.pointerEvents = pos === 0 ? 'auto' : 'none';
        s.classList.toggle('is-current', pos === 0);
      });
      if (instant) { void cf.offsetWidth; requestAnimationFrame(function(){ cf.classList.add('acf-cf--anim'); }); setTimeout(function(){ cf.classList.add('acf-cf--anim'); }, 60); }
      lastW = w; laidOut = true;
      syncRevs();
      manageVideos();
    }
    function clearAdv() { if (advTimer) { clearTimeout(advTimer); advTimer = null; } }
    function schedule() {
      clearAdv();
      if (paused || n < 2) return;
      var v = slides[current].querySelector('video');
      if (advAttr === 'ended') {
        if (v && !loopVideo) {
          v.onended = function () { advance(); };
          advTimer = setTimeout(advance, 15000);           /* red de seguridad */
        } else {
          advTimer = setTimeout(advance, (v ? 8000 : 5000));
        }
      } else {
        var secs = parseFloat(advAttr) || 0;
        if (secs > 0) advTimer = setTimeout(advance, secs * 1000);
      }
    }
    function advance() { current = (current + 1) % n; layout(); schedule(); }
    function manageVideos() {
      slides.forEach(function (s, i) {
        var v = s.querySelector('video'); if (!v) return;
        if (i === current && !paused) {
          var src = v.querySelector('source[data-src]');
          if (src) { src.src = src.getAttribute('data-src'); src.removeAttribute('data-src'); v.load(); }
          if (!v._pw) { v._pw = 1; v.addEventListener('playing', function () { s.classList.add('is-playing'); }); }
          try { v.currentTime = 0; } catch (e) {}
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { s.classList.remove('is-playing'); try { v.pause(); } catch (e) {} }
      });
    }

    /* swipe */
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; clearAdv(); }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 36) { current = (current + (dx < 0 ? 1 : -1) + n) % n; layout(); }
      setTimeout(schedule, 400);
    }, { passive: true });
    /* click en un vecino lo trae al centro */
    slides.forEach(function (s, i) {
      s.addEventListener('click', function () { if (relPos(i) !== 0) { current = i; layout(); clearAdv(); setTimeout(schedule, 400); } });
    });

    /* Re-posiciona SOLO cuando cambia el ancho del carrusel (no al hacer scroll ni
       cuando aparece el header sticky del movil, que dispara resize sin cambiar el
       ancho -> evitamos el salto). ResizeObserver sobre el propio elemento. */
    function onSizeMaybe() {
      if (!laidOut) return;   /* aun no posicionado: lo hara firstLayout() al acercarse */
      var w = slides[0].offsetWidth;
      if (w && Math.abs(w - lastW) > 1) layout(true);
    }
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { clearTimeout(cf._r); cf._r = setTimeout(onSizeMaybe, 120); });
      ro.observe(cf);
    } else {
      window.addEventListener('resize', function () { clearTimeout(cf._r); cf._r = setTimeout(onSizeMaybe, 150); }, { passive: true });
    }
    window.addEventListener('orientationchange', function () { setTimeout(function () { layout(true); }, 250); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { paused = true; clearAdv(); manageVideos(); }
      else { paused = false; layout(); schedule(); }
    });

    function firstLayout() {
      layout(true);
      /* activa las transiciones DESPUES del primer posicionado (si no, el navegador
         deja el transform en identidad al combinar "primera asignacion + transition"). */
      requestAnimationFrame(function () { requestAnimationFrame(function () { cf.classList.add('acf-cf--anim'); }); });
      setTimeout(function () { cf.classList.add('acf-cf--anim'); }, 80);
    }
    /* PERF: el primer layout() lee getComputedStyle y offsetWidth, y eso obliga al navegador
       a maquetar la pagina entera en plena carga (forced reflow). El carrusel esta bajo el
       pliegue, asi que se posiciona cuando queda a 800 px de entrar en pantalla: sobra
       margen para que no se vea el salto. El escenario ya reserva su altura por CSS
       (aspect-ratio), asi que esperar no mueve nada. */
    if ('IntersectionObserver' in window) {
      var nearIo = new IntersectionObserver(function (es) {
        for (var q = 0; q < es.length; q++) {
          if (es[q].isIntersecting) { nearIo.disconnect(); if (!laidOut) firstLayout(); return; }
        }
      }, { rootMargin: '800px 0px' });
      nearIo.observe(cf);
    } else {
      firstLayout();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { paused = false; layout(); schedule(); }
          else { paused = true; clearAdv(); manageVideos(); }
        });
      }, { threshold: 0.35 }).observe(cf);
    } else { paused = false; layout(); schedule(); }
  });
  }
  }

  function acfInitAll(){
    var roots = document.querySelectorAll('[data-acf-mp]');
    for (var i = 0; i < roots.length; i++) acfInitMainProduct(roots[i]);
  }
  acfInitAll();
  /* Editor de temas: al re-renderizar la seccion, el script en linea se re-ejecutaba solo;
     el asset no tiene por que, asi que se re-inicializa aqui (la guarda data-acf-mp-init
     evita montarlo dos veces). */
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-acf-mp]') : null;
    if (r) acfInitMainProduct(r);
  });
})();
